module.exports = __webpack_public_path__ + "static/media/seal_white.11347f21.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/img/seals/MT/seal_white.png
// module id = 1510
// module chunks = 0